/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
class SearchResult {
  constructor({ pageIndex = 0, searchResultIndex = 0, quads = [] }) {
    this.pageIndex = pageIndex;
    this.quads = quads;
    this.searchResultIndex = searchResultIndex;
  }

  equals({ pageIndex, quads }) {
    if (this.pageIndex !== pageIndex) {
      return false;
    } else if (this.quads.length !== quads.length) {
      return false;
    }

    return this.quads.every((currentQuad, index) => quads[index].equals(currentQuad));
  }

  getPageIndex() {
    return this.pageIndex;
  }

  getQuads() {
    return this.quads;
  }

  updateQuads(quads) {
    this.quads = quads;
  }
}

export { SearchResult };
